import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import {
  CancellationThreshold,
  CancellationThresholdData,
} from 'models/Professional/CancellationThreshold.types'

export async function getCancellationThreshold(
  professionalUsername: string
): Promise<CancellationThreshold> {
  const { data } = await axios.get<CancellationThresholdData>(
    apiEndpoints.METRICS_PROFESSIONAL_CANCELLATION_THRESHOLD(professionalUsername)
  )

  const { monthly_threshold, cancellations, remaining } = data

  return {
    monthlyThreshold: monthly_threshold,
    cancellations,
    remaining,
  }
}
